'use client'
import { signOut, useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { useAdminToken } from '@repo/utils/fetcher/admin-fetcher'
import { setUserSelector, useAuthStore } from './use-auth'

const setTokenSelector = (s) => s.setToken

export function UserLoginConfig() {
  const router = useRouter()
  const setUser = useAuthStore(setUserSelector)
  const setToken = useAdminToken(setTokenSelector)
  const { data: session } = useSession()

  useEffect(() => {
    if (session?.user?.error === 'invalid_token' || session?.user?.error === 'session_invalidated') {
      setToken(null)
      // Redirect SPA en el mismo origen (evita el salto de host de callbackUrl,
      // que depende de NEXTAUTH_URL). El catch limpia cookies como fallback duro.
      signOut({ redirect: false })
        .then(() => {
          router.replace('/login')
          router.refresh()
        })
        .catch(() => {
          document.cookie = 'next-auth.session-token=; Max-Age=0; path=/'
          document.cookie = '__Secure-next-auth.session-token=; Max-Age=0; path=/'
          window.location.href = '/login'
        })
      return
    }

    if (session && session.user && (session.user as any).token) {
      const token = (session.user as any).token

      setToken(token)
      setUser({ ...session.user, authToken: token })
    }
  }, [session, setToken, setUser, router])

  return null
}
